// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"94a1ec66","123":"1e4e02a4","311":"16307623","710":"2ef0aa19","787":"7afad598","853":"f901fb07","874":"fe4dbe1b","935":"3cd8198d"}[chunkId] + ".chunk.js";
};